import { Component, OnInit, Inject } from '@angular/core';
// import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Filter, LotteryFilterParam } from '../../models/filter.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class FilterEditorData {
  public cols: number = 10;
  public rows: number = 10;
  public lotteryId: string;
  public numberList: number[] = [];
  public filter:Filter;
  public betId:string;
}

@Component({
  selector: 'kt-filter-editor-dialog',
  templateUrl: './filter-editor-dialog.component.html',
  styleUrls: ['./filter-editor-dialog.component.scss']
})
export class FilterEditorDialogComponent implements OnInit {
  _filterParam: LotteryFilterParam;

  constructor(
    public dialogRef: MatDialogRef<FilterEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterEditorData) {

  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  confirm()
  {
    this.dialogRef.close(this._filterParam );
  };

  public changeParams(filterParam:LotteryFilterParam)
  {
      this._filterParam = filterParam;
  }

}
